import UpdateCategory from "../features/inventory/UpdateCategory"

const UpdateInventoryCategoryPage = () => {
    return (
        <>
            <UpdateCategory />
        </>
    )
}

export default UpdateInventoryCategoryPage